export default __webpack_public_path__ + "static/media/register_illustration.493b3e97.svg";